import { styled } from '@mui/material/styles'
import { Box, ListItemText } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

export const CardOuterWrapper = styled(Box)(`
  width:100%;

  &.exportToPPT > div {padding:0; box-shadow:none;}
  ${exportToPPT_tableCss}

  @media (max-width: ${MEDIA.lg}) {
    padding: 30px 20px 40px;
    
    &.exportToPPT {min-width:1200px; max-width:1200px; width:1200px; }
    &.exportToPPT .relativeBrands{flex-direction:row;}
  }
`)

export const LhsWrap = styled(Box)(`
  width: 100%;
  display:flex;
  justify-content:center;
  align-items:center;

  &.multi-pie-data {
    // max-width : 75%;
  }

  svg {
   overflow : visible;
  }
`)

export const ListItemTextWrap = styled(Box)(`
  // margin-right: 10px;
  display : flex;
  flex-direction : column;
  font-size : 14px;
  line-height : 20px;

  .name {}

  .value {font-weight : 500; }

  &.hide {
    display:none
  }
`)

export const ListValue = styled(Box)((props) => `
  font-weight : 500; 
`)

export const ListWrapper = styled(Box)`
  width : 290px;
  gap: 8px;
  display: flex;
  padding: 6px 0;
`

export const BarContainer = styled(Box)((props) => `
  width: 8px;
  height: 40px;
  border: 1px solid ${props.barcolor ? props.barcolor : '#000'};
  border-radius: 99px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;

  & .bar-fill {
    display: block;
    width: 100%;
    border-radius: 0 0 20px 20px;
    transition: height 0.3s ease;
  }
`)

export const RhsWrap = styled(Box)(`
  min-width: 450px;
  // padding-left: 80px;
  display:flex;
  justify-content:start;
  flex-wrap:wrap;
  align-items: flex-start;

  @media (max-width: 1280px) {
    padding-left: 50px !important;
  }
  @media (max-width: 760px) {
    min-width: 100%;
  }
`)